import React from "react";
import { Form, Button, Typography } from "antd";
import { RightOutlined } from "@ant-design/icons";
import FormItemPassword from "../../components/FormItems/FormItemPassword";
import ButtonComponent from "../../components/Button/Button";

const { Title } = Typography;

const ChangePasswordForm = ({
  form,
  onFinish,
  validatePassword,
  submitText = "Submit",
}) => {
  return (
    <>
      

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        requiredMark
      >
        <FormItemPassword
          label="Current Password"
          name="currentPassword"
          placeholder="Enter Current Password"
          rules={[
            { required: true, message: "Current Password is required" },
          ]}
        />

        <FormItemPassword
          label="New Password"
          name="newPassword"
          placeholder="Enter New Password"
          rules={[
            { required: true, message: "New Password is required" },
            { validator: validatePassword },
          ]}
        />

        <FormItemPassword
          label="Confirm Password"
          name="confirmPassword"
          placeholder="Enter Confirm Password"
          dependencies={["newPassword"]}
          rules={[
            { required: true, message: "Confirm Password is required" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("Passwords do not match")
                );
              },
            }),
          ]}
        />

        <Form.Item style={{ marginTop: 32, textAlign: "center" }}>
            <ButtonComponent type="primary" htmlType="submit" shape="round" text={submitText} />
         
          {/* <Button
            type="primary"
            htmlType="submit"
            shape="round"           
          >
            {submitText} <RightOutlined />
          </Button> */}
        </Form.Item>
      </Form>
    </>
  );
};

export default ChangePasswordForm;
